import type { CalculationType } from '@api/calculationType';
import { formatCurrency, formatPercent } from '../../utils/formatters';

export function formatAmount(amount: string, type: CalculationType): string {
  const value = parseFloat(amount);
  switch (type) {
    case 'percentage':
      return formatPercent(value);
    case 'pax':
      return `${formatCurrency(value)} per guest`;
    case 'flat':
      return formatCurrency(value);
  }
}
